<strong>Disclaimer:</strong> This sample dapp is intended exclusively for experimental
purpose. The backend canister may be removed or reinstalled at any time without prior
notice. You are advised not to use this dapp for storing your critical data such
as keys or passwords.
